export default class UserState {
  private static readonly nameLocalStorageKey: string = "EatOut_UserState_name";

  private _name: string | null;
  private _id: string | null;

  constructor() {
    this._name = localStorage.getItem(UserState.nameLocalStorageKey);
    this._id = null;
  }

  public get name(): string | null {
    return this._name;
  }

  public set name(name: string | null) {
    if (name === null) {
      localStorage.removeItem(UserState.nameLocalStorageKey);
    } else {
      localStorage.setItem(UserState.nameLocalStorageKey, name);
    }
    this._name = name;
  }

  public get id(): string | null {
    return this._id;
  }

  public set id(id: string | null) {
    this._id = id;
  }
}
